import type { DbModuleFile } from '~src/types/db';
import { appLog } from '~src/utils/log';
import { getLinkModuleFile, getModuleFileTwo } from '~src/services/api/modules';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';
import { message } from 'antd';

export const downloadModuleFile = async (
  moduleFile: DbModuleFile,
  onDownloadStarted?: () => unknown
) => {
  appLog('downloadModuleFile -> ', moduleFile);

  if (!moduleFile.location) throw new Error('No location provided');

  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
  onDownloadStarted && onDownloadStarted();

  try {
    const blob = await getModuleFileTwo({
      projectId: String(moduleFile.project_id),
      moduleFileId: String(moduleFile.id),
      moduleId: moduleFile.module,
      response_type: 'base64',
    });

    saveFromLink(blob, moduleFile.file_name);
  } catch (err) {
    appLog('ERR_DOWNLOAD_MULTIPLE_FILES -> ', err);
    message.error(`${err}`);
  }

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3_000);
};
